import React from 'react';
import '../ui.css';

const PageHeader = ({ eyebrow, title, descripcion, actions }) => {
    return (
        <div className="ui-page-header">
            <div>
                {eyebrow && <div className="ui-eyebrow">{eyebrow}</div>}
                <h3 className="ui-title">{title}</h3>
                {descripcion && <p className="ui-descripcion">{descripcion}</p>}
            </div>
            {actions && <div className="ui-actions">{actions}</div>}
        </div>
    );
};

export default PageHeader;
